import script from "./SelectTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectTemplateModal.vue?vue&type=style&index=0&id=002a3def&lang=less&scoped=true"
script.__scopeId = "data-v-002a3def"

export default script